import { io } from "socket.io-client";
import { store } from "../reduxStore/store";
import {
  setRoomDetails,
  setSocketConnected,
  setParticipantsList,
  updParticipantsList,
  remParticipantsList,
  setExtensionShow,
  setExtensionDetails,
  setFeatureMsg,
  setMediaControls,
  setVideoContainerSettings,
  setRecentUnmutedUsers,
  setTimerExtensionShow,
  setTimerExtensionDetails,
  setActiveTimerWidget,
  setPlayYoutubeDetails,
} from "../reduxStore/confSlice";
import { getWidgetCode, } from "./util";
import { socketURL } from "./constants";
import { SOCKET_EVENTS } from "./socketEvents";
import { _disableSubtitles, _requestingSubtitlesChange, setLocalParticipantLanguage } from "../libs";
import { handleActiveTimer } from "./functions";

let socket = null;
const { dispatch } = store;

export const socketConnect = (room, token) => {
  return new Promise((resolve) => {
    console.log('socketURL', socketURL);
    socket = io.connect(socketURL, {
      reconnection: true,
      reconnectionDelay: 1000,
      reconnectionDelayMax: 5000,
      reconnectionAttempts: 99999,
    });

    socket.on("connect", () => {
      if (socket.connected) {
        socket.emit(
          SOCKET_EVENTS.CON,
          {
            room,
            token,
          },
          (response) => {
            dispatch(setSocketConnected(true));
            console.log("con response", response);
            return resolve(response);
          }
        );
      }
    });

    ///

    socket.io.on("ping", () => {
      console.log("socket.ping");
    });

    socket.on("disconnect", () => {
      console.log("socket.disconnect");
    });

    socket.io.on("reconnect", (attempt) => {
      console.log("socket.reconnect", attempt);
    });

    socket.io.on("reconnect_attempt", (attempt) => {
      console.log("socket.reconnect_attempt", attempt);
    });

    socket.io.on("reconnect_error", (error) => {
      console.log("socket.reconnect_error", error);
      return resolve({ status: 500, data: "socket.reconnect_error" });
    });

    socket.io.on("reconnect_failed", () => {
      console.log("socket.reconnect_failed");
      return resolve({ status: 500, data: "socket.reconnect_failed" });
    });

    ///
    socket.on(SOCKET_EVENTS.ALL, (data) => {
      dispatch(setParticipantsList(data));
      const state = store.getState();
      const { roomDetail } = state.conf;

      if (roomDetail?.breakout) {
        let filteredUsers = data.filter(v => !v?.breakout_id);
        dispatch(setParticipantsList(filteredUsers));
      } else {
        dispatch(setParticipantsList(data));
      }
    });

    socket.on(SOCKET_EVENTS.UPD, (data) => {
      const state = store.getState();
      const { roomDetail } = state.conf;

      if (roomDetail?.breakout) {
        if (!data?.breakout_id) {

          dispatch(updParticipantsList(data));
        } else {

          if (!data.jid && data.prevJid) {
            data.jid = data.prevJid;
          }
          dispatch(remParticipantsList(data));
        }
      } else {
        dispatch(updParticipantsList(data));
      }


    });

    socket.on(SOCKET_EVENTS.ADD, (data) => {
      const state = store.getState();
      const { roomDetail } = state.conf;

      if (roomDetail?.breakout) {
        if (!data?.breakout_id) {
          dispatch(updParticipantsList(data));
        } else {
          if (!data.jid && data.prevJid) {
            data.jid = data.prevJid;
          }
          dispatch(remParticipantsList(data));
        }
      } else {
        dispatch(updParticipantsList(data));
      }
    });

    socket.on(SOCKET_EVENTS.REM, (data) => {
      dispatch(remParticipantsList(data));
    });

    socket.on(SOCKET_EVENTS.ROOM_UNMUTED_LIST, doc => {
      dispatch(setRecentUnmutedUsers(doc));
    });

    socket.on(SOCKET_EVENTS.ROOM_SETTINGS, (doc) => {
      const state = store.getState();
      const { roomDetail, localUser, event_promoter, videoContainerSettings } =
        state.conf;
      if (
        videoContainerSettings?.show_speaker_on_presentation !==
        doc?.show_speaker_on_presentation ||
        videoContainerSettings?.show_names_on_videos !==
        doc?.show_names_on_videos ||
        videoContainerSettings?.hide_muted_attendees !==
        doc?.hide_muted_attendees
      ) {
        const show_speaker_on_presentation =
          doc?.show_speaker_on_presentation ??
          videoContainerSettings?.show_speaker_on_presentation;
        const show_names_on_videos =
          doc?.show_names_on_videos ??
          videoContainerSettings?.show_names_on_videos;
        const hide_muted_attendees =
          doc?.hide_muted_attendees ??
          videoContainerSettings?.hide_muted_attendees;
        dispatch(
          setVideoContainerSettings({
            show_speaker_on_presentation,
            show_names_on_videos,
            hide_muted_attendees,
          }),
        );
      }
      const tempRoomDetail = { ...roomDetail, ...doc };
      console.log('on room-settings', tempRoomDetail?.recording_view);
      dispatch(setRoomDetails(tempRoomDetail));
    });

    //extensions
    socket.on(SOCKET_EVENTS.SHOW, doc => {

      if (doc.extensionid === getWidgetCode('hide-popup')) {
        dispatch(setExtensionShow(false));
        dispatch(setExtensionDetails({}));
      } else {
        dispatch(setExtensionShow(true));
        dispatch(setExtensionDetails(doc));
      }
    });

    socket.on(SOCKET_EVENTS.HIDE, doc => {
      console.log('extensions - hide', doc);
      dispatch(setExtensionShow(false));
      dispatch(setExtensionDetails({}));
    });


    socket.on(SOCKET_EVENTS.TIMER_SHOW, doc => {
        handleActiveTimer(doc, 'timer-show');
    });

    socket.on(SOCKET_EVENTS.TIMER_HIDE, doc => {
      dispatch(setTimerExtensionShow(false));
      dispatch(setTimerExtensionDetails({}));

      dispatch(setActiveTimerWidget({}));
     
    });

    socket.on(SOCKET_EVENTS.MSG_FEATURED, doc => {
      dispatch(setFeatureMsg(doc));
    });

    socket.on(SOCKET_EVENTS.MSG_UNFEATURED, () => {
      dispatch(setFeatureMsg({}));
    });

    socket.on(SOCKET_EVENTS.MEDIA_SET, doc => {
      dispatch(setMediaControls(doc));
    });

    socket.on(SOCKET_EVENTS.LEM_REQUEST_CAPTION, doc => {
       if(doc){
        _requestingSubtitlesChange(doc)
       }
    });
    socket.on(SOCKET_EVENTS.LEM_CAPTION_LANGUAGE, doc => {
      if(doc){
        console.log('doc',doc)
        setLocalParticipantLanguage(doc)
       }
    });
    socket.on(SOCKET_EVENTS.LEAVE_TRANSCRIBER, doc => {
      if(doc){
        console.log('_disableSubtitles',doc)
        _disableSubtitles();
       }
    });
    socket.on(SOCKET_EVENTS.WIDGET_FOLDER_ITEM_SYNC_CONTROL, doc => {
      // dispatch(setPlayYoutubeDetails(doc));
    });
  });
};

///

export const addParticipant = (doc) => {
  return new Promise((resolve) => {
    socket.emit(SOCKET_EVENTS.ADD, doc, (res) => {
      return resolve(res);
    });
  });
};

export const remParticipant = (doc) => {
  return new Promise((resolve) => {
    socket.emit(SOCKET_EVENTS.REM, doc, (res) => {
      return resolve(res);
    });
  });
};

export const disposeMeetnSocketConnection = () => {
  if (socket) {
    socket.disconnect();
  }
};

export const getTimerActive = doc => {
  return new Promise(resolve => {
    socket.emit(SOCKET_EVENTS.TIMER_WIDGET_ACTIVE, doc, res => {
      return resolve(res);
    });
  });
};

export const getActiveWidget = doc => {
  return new Promise(resolve => {
    socket.emit(SOCKET_EVENTS.WIDGET_ACTIVE, doc, res => {
      return resolve(res);
    });
  });
};
export const sendCaptionMsg = doc => {
  return new Promise(resolve => {
    socket.emit(SOCKET_EVENTS.CAPTION_MSG, doc, res => {
      return resolve(res);
    });
  });
};
export const updateDominantData = doc => {
  return new Promise(resolve => {
    socket.emit(SOCKET_EVENTS.EVENT_TRANSLATION_UPD, doc, res => {
      return resolve(res);
    });
  });
};